import React, { useEffect, useState } from "react";
import "./Blogs.css";
import { Row, Col, Card, Button } from "react-bootstrap";
import { FaCalendarAlt, FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { fetchBlogs } from "../../services/api";
import Loader from "../common/Loader";

const Blogs = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBlogs()
      .then((data) => {
        setBlogs(Array.isArray(data.data) ? data.data : []);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Failed to fetch blogs");
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="blogs">
        <Loader fullPage message="Loading blogs..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="blogs">
        <div className="coustom_container">
          <p className="text-danger">Error: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="blogs">
      <div className="coustom_container">
        <h2>Health Blogs & Medical Insights</h2>
        <p className="blogs_subtitle">
          Stay informed with expert healthcare articles, diagnostic awareness
          and wellness tips.
        </p>

        <Row>
          {blogs.map((blog) => (
            <Col lg={4} md={6} sm={12} key={blog.id || blog._id} className="mb-4">
              <Card className="blog_card shadow border-0">
                <div className="blog_img_wrap">
                  <Card.Img src={blog.image} />
                </div>

                <Card.Body>
                  <div className="blog_date">
                    <FaCalendarAlt />{" "}
                    {blog.createdAt
                      ? new Date(blog.createdAt).toLocaleDateString()
                      : "Unknown Date"}
                  </div>

                  <Card.Title>{blog.title}</Card.Title>

                  <Button
                    className="read_more_btn"
                    onClick={() =>
                      navigate(`/blog/${blog.url}`, { state: blog })
                    }
                  >
                    Read More <FaArrowRight />
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default Blogs;
